export default "__VITE_ASSET__C7h4x7yD__"